/* screens/auth/Forgot.jsx — Восстановление пароля (S12, /forgot).
   Anti-enumeration: бэк всегда 200 → всегда /email-sent (mode=reset). ХЕНДОФФ → pages/auth/Forgot.jsx. */

import React from 'react';
import { Button } from '../../components/ui/Button.jsx';
import { BackLink } from '../../components/ui/Buttons.jsx';
import { Field, TextInput } from '../../components/ui/Field.jsx';
import { ScreenHeader } from '../../components/ui/Metric.jsx';
import { authReal } from '../../lib/adapters/auth.js';
import { RR } from '../../lib/router.jsx';

  const { useState } = React;
  const { useNavigate, Link } = RR;

  function Forgot() {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
      e.preventDefault();
      if (!/^\S+@\S+\.\S+$/.test(email)) { setError('Введите корректный email.'); return; }
      setError(null); setLoading(true);
      // Anti-enumeration: бэк всегда 200 (письмо уходит только если юзер есть). Возможный 429
      // (rate_limited) гасим — UX всё равно ведёт на /email-sent, факт существования не палим.
      try { await authReal.requestPasswordReset(email); } catch (err) {}
      navigate('/email-sent', { state: { email, mode: 'reset' } });
    };

    return (
      <form className="auth-form stack stack-16" onSubmit={submit} noValidate>
        <BackLink to="/signin">Войти</BackLink>
        <ScreenHeader eyebrow="Сброс пароля" title="Забыли пароль?"
          subtitle="Пришлём ссылку для сброса. Она действует 30 минут." />

        <Field label="E-mail" htmlFor="fg-email" error={error}>
          <TextInput id="fg-email" type="email" value={email} autoComplete="email" invalid={error ? true : undefined}
            placeholder="you@restaurant.ru" onChange={(e) => setEmail(e.target.value)} />
        </Field>

        <Button type="submit" variant="primary" size="lg" loading={loading} className="full">Отправить ссылку</Button>

        <p className="auth-form__alt t-body text-dim">
          Вспомнили? <Link to="/signin" className="link">Войти</Link>
        </p>
      </form>
    );
  }

export { Forgot };
